import { useTranslation } from "react-i18next";
import PageShell, { Breadcrumb } from "@/components/feature/PageShell";

const brandReports = [
  { date: "2025年12月", title: "全球品牌競爭力季度報告（2025 Q4）", desc: "全面分析2025年第四季度全球主要經濟體品牌競爭力變化趨勢，重點關注亞太地區品牌崛起態勢及數字化轉型對品牌競爭力的影響。", image: "https://readdy.ai/api/search-image?query=Professional%20business%20report%20cover%20with%20elegant%20data%20visualization%20elements%2C%20warm%20sophisticated%20color%20palette%2C%20clean%20modern%20layout%2C%20corporate%20publishing%20aesthetic%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=brand-report-01&orientation=landscape" },
  { date: "2025年11月", title: "中國品牌國際化發展趨勢分析", desc: "深入分析中國品牌在海外市場的佈局策略、市場表現和消費者認知，探討中國品牌從「走出去」到「走上去」的升級路徑。", image: "https://readdy.ai/api/search-image?query=Abstract%20global%20map%20with%20flowing%20connection%20lines%20and%20data%20points%2C%20warm%20professional%20color%20scheme%2C%20clean%20modern%20infographic%20style%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=brand-report-02&orientation=landscape" },
  { date: "2025年10月", title: "奢侈品牌亞洲市場表現深度剖析", desc: "聚焦全球頂級奢侈品牌在亞洲市場的品牌策略和市場表現，分析後疫情時代亞洲消費者品牌消費行為的結構性變化。", image: "https://readdy.ai/api/search-image?query=Elegant%20luxury%20retail%20atmosphere%20with%20sophisticated%20storefront%20design%2C%20warm%20golden%20lighting%2C%20high-end%20shopping%20aesthetic%2C%20clean%20modern%20style%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=brand-report-03&orientation=landscape" },
  { date: "2025年9月", title: "數字時代品牌傳播新範式研究報告", desc: "研究社交媒體、短視頻平台和直播電商等新興渠道對品牌傳播模式的變革性影響，提出品牌數字化傳播的系統性策略框架。", image: "https://readdy.ai/api/search-image?query=Modern%20digital%20media%20abstract%20with%20flowing%20data%20streams%20and%20social%20network%20connections%2C%20warm%20professional%20color%20palette%2C%20clean%20tech%20aesthetic%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=brand-report-04&orientation=landscape" },
  { date: "2025年8月", title: "粵港澳大灣區品牌生態發展白皮書", desc: "系統梳理粵港澳大灣區品牌生態的發展現狀、競爭格局和未來趨勢，為區域品牌協同發展提供戰略建議。", image: "https://readdy.ai/api/search-image?query=Modern%20cityscape%20with%20interconnected%20skyline%20and%20flowing%20data%20visualization%20overlay%2C%20warm%20professional%20aesthetic%2C%20clean%20futuristic%20style%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=brand-report-05&orientation=landscape" },
  { date: "2025年7月", title: "ESG與品牌價值關聯性研究報告", desc: "量化分析環境、社會和公司治理（ESG）表現對品牌價值的影響，為企業品牌戰略與可持續發展的融合提供數據支撐。", image: "https://readdy.ai/api/search-image?query=Abstract%20sustainability%20concept%20with%20green%20growth%20elements%20and%20circular%20design%20motifs%2C%20warm%20natural%20color%20palette%2C%20clean%20modern%20aesthetic%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=brand-report-06&orientation=landscape" },
];

export default function NewsBrand() {
  const { t } = useTranslation();
  return (
    <PageShell>
      <section className="relative pt-24 pb-20 bg-gradient-to-b from-secondary-900 to-secondary-800 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=Abstract%20magazine%20cover%20design%20with%20elegant%20layout%20grid%20and%20subtle%20graphic%20elements%2C%20jade%20green%20background%2C%20editorial%20publishing%20aesthetic%2C%20warm%20lighting%2C%20no%20text%2C%20no%20people&width=1600&height=600&seq=brand-report-hero-01&orientation=landscape')] bg-cover bg-center opacity-15"></div>
        <div className="relative w-full max-w-7xl mx-auto px-4 md:px-8">
          <Breadcrumb items={[{ label: t("nav.news") }, { label: t("news.brand.title") }]} />
          <div className="mt-6 max-w-3xl">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 leading-tight">
              {t("news.brand.title")}
            </h1>
            <p className="mt-4 text-lg text-background-100/80 leading-relaxed">
              {t("news.brand.subtitle")}
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {brandReports.map((report, i) => (
              <div key={i} className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer flex flex-col sm:flex-row">
                <div className="w-full sm:w-48 h-40 sm:h-auto flex-shrink-0 overflow-hidden">
                  <img src={report.image} alt={report.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="p-5 flex-1 flex flex-col justify-center">
                  <span className="text-xs font-medium text-secondary-600 mb-1.5">{report.date}</span>
                  <h3 className="font-heading font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors">{report.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{report.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Real Brand Network Coverage from Shopify */}
      <section className="py-16 md:py-20 bg-background-100">
        <div className="w-full max-w-4xl mx-auto px-4 md:px-8">
          {/* Attendee Intro */}
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 leading-tight mb-6">
              {t("news.brand.coverage.heading")}
            </h2>
            <p className="text-foreground-600 leading-relaxed max-w-3xl mx-auto">
              {t("news.brand.coverage.intro")}
            </p>
          </div>

          {/* Banner Image */}
          <div className="w-full overflow-hidden rounded-lg mb-12">
            <img
              src="https://iabs.com.hk/cdn/shop/files/2nd_cover_03.jpg?v=1779076655"
              alt="Second World Brand Conference"
              className="w-full h-auto object-cover object-top"
            />
          </div>

          {/* Full Quote */}
          <div className="bg-background-50 rounded-lg p-6 md:p-10">
            <p className="text-foreground-700 leading-relaxed text-base md:text-lg mb-8">
              {t("news.brand.coverage.quote")}
            </p>
            <a
              href="https://www.52hrtt.com/xg/n/w/info/D1776742276393"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-background-50 rounded-md hover:bg-primary-700 transition-colors font-medium text-sm whitespace-nowrap"
            >
              {t("news.brand.coverage.readMore")}
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>
    </PageShell>
  );
}